import { useLocation } from '@tanstack/react-router'
import { ComponentProps, FC, createElement } from 'react'

import BaseErrorBoundary from './BaseErrorBoundary'

const ErrorBoundary: FC<Omit<ComponentProps<typeof BaseErrorBoundary>, 'location'>> = (
  props,
) => {
  const location = useLocation()
  return createElement(BaseErrorBoundary, { ...props, location })
}

export default ErrorBoundary
